/**
 * Component for the final page of our Return-Portal
 * where a customer is informed that the Return
 * request has been received. If a shipping-label
 * is involved this will also be downloadable on this
 * page.
 *
 * @component
 */

import { Card, Col, Divider, Result, Row, Spin, message } from 'antd';
import { CheckCircleTwoTone } from '@ant-design/icons';
import axios from 'axios';
import React from 'react';
import { FormattedMessage } from 'react-intl';
class Status extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      labelUrl: undefined,
      trackingUrl: undefined,
      loading: true,
      labelQRcodeUrl: undefined,
      error: false,
      returnNumber: props.returnNumber || new URL(window.location.href).searchParams.get('returnNumber'),
      companyIdentifier: props.companyIdentifier || new URL(window.location.href).searchParams.get('identifier'),
    };
  }

  async componentDidMount() {
    // scroll to top of page
    window.scrollTo(0, 0);

    try {
      const { companyIdentifier, returnNumber } = this.state;
      if (!companyIdentifier || !returnNumber) {
        throw new Error('Missing required parameters');
      }

      const response = await axios.post('/api/visitors/return/summary', {
        companyIdentifier,
        returnNumber,
      });message.success('Successfully created your return.', 4);
      return this.setState({
        loading: false,
        ...response.data,
      });
    } catch (err) {
      message.error(
        'There was an error submitting your return. Please try again or contact support.',
        10
      );
      this.setState({
        loading: false,
        error: true,
      });
    }
  }
  SafeFormattedMessage = ({ id, values, ...props }) => {
    return (
      <FormattedMessage
        id={id}
        values={values}
        {...props}
      >
        {(formattedMessage) => {
          const messageText = String(formattedMessage);
          // If the formatted message is the same as the ID, return empty string
          return messageText === id ? "" : formattedMessage;
        }}
      </FormattedMessage>
    );
  };
  render() {
    return (
      <React.Fragment>
        <Card
          title={
            <FormattedMessage
              id="app.visitor.status.headline"
              description="Title of the last step of the return-portal process 'status page'"
              defaultMessage="Summary of your return"
            />
          }
          className="textCenter"
        >
          <Row style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} className="textCenter">
            <Col span={14}>
              {this.state.loading ? (
                <Col span={24}>
                  <Spin size="large" />
                </Col>
              ) : null}
              {this.state.error ? (
                <Result
                  status="warning"
                  title="There was an error submitting your return. Please try again or contact support."
                />
              ) : null}
              {!this.state.loading &&
              !this.state.error &&
              !this.state.labelUrl ? (
                  <React.Fragment>
                    <CheckCircleTwoTone 
                      twoToneColor="#52c41a" 
                      style={{ fontSize: '100px', marginBottom: '20px' }} 
                    />
                    <h1 style={{ textAlign: 'center' }}>
                      <FormattedMessage
                        id="app.visitor.status.message"
                        description="Top message of the last step of the return-portal process 'status page'"
                        defaultMessage="Congrats!"
                      />
                    </h1>
                    <h3 style={{ textAlign: 'center' }}>
                      <FormattedMessage
                        id="app.visitor.status.infoViaEmail"
                        description="Instructions via email message"
                        defaultMessage="We will email the instructions to you once your request has been approved. Please check your inbox and spam folder."
                      />
                    </h3>
                    <h3 style={{ textAlign: 'center', marginTop: '10px' }}>
                      <this.SafeFormattedMessage
                        id="app.visitor.status.RmaNumber"
                        description="RMA-number on the Confirmation Page"
                        values={{
                          RMA_NUMBER: this.state.returnNumber,
                          ORDER_NAME: this.props.orderNumber,
                          ORDER_ID: this.props.orderId,
                        }}
                      />
                    </h3>
                  </React.Fragment>
                ) : null}
              {!this.state.loading &&
              !this.state.error &&
              this.state.labelUrl ? (
                  <React.Fragment>
                    <CheckCircleTwoTone 
                      twoToneColor="#52c41a" 
                      style={{ fontSize: '100px', marginBottom: '20px' }} 
                    />
                    <h1 style={{ textAlign: 'center' }}>
                      <FormattedMessage
                        id="app.visitor.status.message"
                        description="Top message of the last step of the return-portal process 'status page'"
                        defaultMessage="Congrats!"
                      />
                    </h1>
                    <h2 style={{ textAlign: 'center' }}>
                      <FormattedMessage
                        id="app.visitor.status.labelInfo"
                        description="Instructions for prepaid return label"
                        defaultMessage="Please check your inbox (and spam folder) for instructions"
                      />
                    </h2>
                    <h3 style={{ textAlign: 'center' }}>
                      <FormattedMessage
                        id="app.visitor.status.labelDownload"
                        description="Download link-text for prepaid shipping label"
                        defaultMessage="You can download your shipping-label here"
                      />
                    :{' '}
                      <a
                        href={this.state.labelUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                      Link
                      </a>
                    </h3>
                    <h3 style={{ textAlign: 'center' }}>
                      <FormattedMessage
                        id="app.visitor.status.labelTrack"
                        description="Tracking link-text for prepaid shipping label"
                        defaultMessage="You can track your shipment after approx. 24 hours here"
                      />
                    :{' '}
                      <a
                        href={this.state.trackingUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                      Link
                      </a>
                    </h3>
                    <h3 style={{ textAlign: 'center', marginTop: '10px' }}>
                      <this.SafeFormattedMessage
                          id="app.visitor.status.RmaNumber"
                          description="RMA-number on the Confirmation Page"
                          values={{
                            RMA_NUMBER: this.state.returnNumber,
                            ORDER_NAME: this.props.orderNumber,
                            ORDER_ID: this.props.orderId,
                          }}
                        />
                    </h3>
                    {this.state.labelQRcodeUrl ? (
                      <h3 style={{ textAlign: 'center' }}>
                        <FormattedMessage
                          id="app.visitor.status.labelQRcodeUrl"
                          description="QR-Code for your shipment"
                          defaultMessage="QR-Code for your shipment"
                        />
                      : <img src={this.state.labelQRcodeUrl} alt="QR-Code" />
                      </h3>
                    ) : null}
                  </React.Fragment>
                ) : null}
            </Col>
            {!this.state.loading &&
              !this.state.error &&
              this.state.shippingAddress ? (
              <Col span={10} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                <React.Fragment>
                  <h3 style={{ textAlign: 'center', marginTop: '10px' }}>
                    <FormattedMessage
                      id="app.visitor.status.address"
                      description="Address on the Confirmation Page"
                      defaultMessage="Your Shipping Address"
                    />
                  </h3>
                  {this.state.shippingAddress?.name &&
                    <p style={{ textAlign: 'center', marginTop: '10px' }}>
                      <FormattedMessage
                        id="app.visitor.status.addressName"
                        description="shipping name the Confirmation Page"
                        defaultMessage="Name: {name}"
                        values={{
                          name: this.state.shippingAddress.name
                        }}
                      />
                    </p>
                  }
                  <p style={{ textAlign: 'center', marginTop: '10px' }}>
                    <FormattedMessage
                      id="app.visitor.status.addressLine1"
                      description="shipping address line 1 the Confirmation Page"
                      defaultMessage="Address Line 1: {addressLine1}"
                      values={{
                        addressLine1: this.state.shippingAddress.address1
                      }}
                    />
                  </p> 
                  {this.state.shippingAddress?.address2 &&
                    <p style={{ textAlign: 'center', marginTop: '10px' }}>
                      <FormattedMessage
                        id="app.visitor.status.addressLine2"
                        description="shipping address line 2 on the Confirmation Page"
                        defaultMessage="Address Line 2: {addressLine2}"
                        values={{
                          addressLine2: this.state.shippingAddress.address2
                        }}
                      />
                    </p>     
                  }    
                  <p style={{ textAlign: 'center', marginTop: '10px' }}>
                    <FormattedMessage
                      id="app.visitor.status.addressCity"
                      description="shippinng city on the Confirmation Page"
                      defaultMessage="City: {city}"
                      values={{
                        city: this.state.shippingAddress.city
                      }}
                    />
                  </p>     
                  <p style={{ textAlign: 'center', marginTop: '10px' }}>
                    <FormattedMessage
                      id="app.visitor.status.addressProvince"
                      description="shippinng province on the Confirmation Page"
                      defaultMessage="Province: {province}"
                      values={{
                        province: this.state.shippingAddress.state
                      }}
                    />
                  </p>     
                  <p style={{ textAlign: 'center', marginTop: '10px' }}>
                    <FormattedMessage
                      id="app.visitor.status.addressZip"
                      description="shippinng zip code on the Confirmation Page"
                      defaultMessage="Zip Code: {zip}"
                      values={{
                        zip: this.state.shippingAddress.zip
                      }}
                    />
                  </p>     
                  <p style={{ textAlign: 'center', marginTop: '10px' }}>
                    <FormattedMessage
                      id="app.visitor.status.addressCountry"
                      description="shippinng country on the Confirmation Page"
                      defaultMessage="Country: {country}"
                      values={{
                        country: this.state.shippingAddress.country
                      }}
                    />
                  </p>     
                </React.Fragment>
              </Col>
              ) : null}

          </Row>
          <Divider />
          <Row type="flex" justify="center" align="top">
            <Col>
              <p>
                <FormattedMessage
                  id="app.visitor.status.contact"
                  description="Contact info for customer"
                  defaultMessage="If you need a helping hand contact us at"
                />{' '}
                <a
                  style={{ textDecoration: 'underline' }}
                  href={'mailto:' + this.props.contactEmail}
                >
                  {this.props.contactEmail}
                </a>
                .
              </p>
            </Col>
          </Row>
        </Card>
      </React.Fragment>
    );
  }
}

export default Status;
